import React, { Component } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import $ from "jquery"
import Toggle from "react-toggle"
import { SingleDatePicker } from "react-dates"
import moment from "moment"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import DeprecatedUserSelect from "../../common/user/selection.component"
class BulkAccountStatementsCreationForm extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            sendEmail: false,
            needToPrint: false,
            onlyPrintNoEmail: false,
            userId: "",
            date: moment(),
            onClose: this.props.onClose || function() {},
            onChange: this.props.onChange || function() {}
        }
        this.onChange = this.onChange.bind(this)
        this.onChange()
    }

    onChange() {
        this.state.onChange({
            sendEmail: this.state.sendEmail,
            needToPrint: this.state.needToPrint,
            onlyPrintNoEmail: this.state.onlyPrintNoEmail,
            date: this.state.date,
            userId: this.state.userId
        })
    }

    render() {
        return (
            <div>
                <div className={"row d-flex justify-content-center"}>
                    <div className={"col-8 pb-4 text-center"}>
                        <em>
                            <FormattedMessage
                                id="bulk.operations.account_statements.description"
                                defaultMessage="Account statements will be created only if the account has a balance"
                            />
                        </em>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="date">
                        <FormattedMessage id="bulk.operations.account_statements.date" defaultMessage="Date" />
                    </label>
                    <div className="col-9">
                        <SingleDatePicker
                            small
                            block
                            displayFormat="LL"
                            focused={this.state.focused}
                            isOutsideRange={() => false}
                            onDateChange={date => {
                                this.setState(
                                    {
                                        date: date
                                    },
                                    this.onChange
                                )
                            }}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            date={this.state.date}
                            numberOfMonths={1}
                            id={"date"}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="sendEmail">
                        <FormattedMessage id="bulk.operations.account_statements.send_email" defaultMessage="Send email" />
                    </label>
                    <div className="col-9 d-flex align-items-center">
                        <div className="input-group">
                            <Toggle
                                id={"sendEmail"}
                                defaultChecked={this.state.sendEmail}
                                checked={this.state.sendEmail}
                                icons={false}
                                onChange={() => {
                                    this.setState(
                                        {
                                            sendEmail: !this.state.sendEmail
                                        },
                                        this.onChange
                                    )
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="needToPrint">
                        <FormattedMessage id="bulk.operations.account_statements.print" defaultMessage="Prepare to print" />
                    </label>
                    <div className="col-9 d-flex align-items-center">
                        <div className="input-group">
                            <Toggle
                                id={"needToPrint"}
                                defaultChecked={this.state.needToPrint}
                                checked={this.state.needToPrint}
                                icons={false}
                                onChange={() => {
                                    this.setState(
                                        {
                                            needToPrint: !this.state.needToPrint
                                        },
                                        this.onChange
                                    )
                                }}
                            />
                        </div>
                    </div>
                </div>
                {this.state.needToPrint ? (
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="onlyPrintNoEmail">
                            <FormattedMessage
                                id="bulk.operations.account_statements.print_only_if_no_email"
                                defaultMessage="Print only if no email"
                            />
                        </label>
                        <div className="col-9 d-flex align-items-center">
                            <div className="input-group">
                                <Toggle
                                    id={"onlyPrintNoEmail"}
                                    defaultChecked={this.state.onlyPrintNoEmail}
                                    checked={this.state.onlyPrintNoEmail}
                                    icons={false}
                                    onChange={() => {
                                        this.setState(
                                            {
                                                onlyPrintNoEmail: !this.state.onlyPrintNoEmail
                                            },
                                            this.onChange
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {AppContext.getUserLoggedIn() && AppContext.getUserLoggedIn().attributes.superUser ? (
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="userId">
                            <FormattedMessage
                                id="bulk.operations.account_statements.user"
                                defaultMessage="Create statements with"
                            />
                        </label>
                        <div className="col-9 d-flex align-items-center">
                            <DeprecatedUserSelect
                                multi={false}
                                value={this.state.userId}
                                onChange={userId => {
                                    this.setState(
                                        {
                                            userId: userId
                                        },
                                        this.onChange
                                    )
                                }}
                                clearable={true}
                                style={{ width: "300px" }}
                            />
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        )
    }
}

export default injectIntl(BulkAccountStatementsCreationForm)



// WEBPACK FOOTER //
// ./src/bulk/operations/account-statements-creation.component.jsx